import { ActionTree } from 'vuex'
import { NotificationsState, notificationsMutationTypes } from '@/store/modules/notifications/notificationsTypes'
import { RootState, ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { MainService } from '@/services/MainService'
import { ExternalService } from '@/services/ExternalService'
import { DialogTypes } from '@/store/modules/dialog/dialogTypes'

const dialogModule: string = ModuleNamespaces.DIALOG

export const actions: ActionTree<NotificationsState, RootState> = {
  async sendMailNotification({ dispatch }, { templateType, notificationData }) {
    try {
      const url = `/mail/template/${templateType}/send`
      const { data } = await new MainService().postData(url, notificationData)
      const message = data.exceptionDesc
      dispatch(
        `${dialogModule}/showDialog`,
        {
          type: DialogTypes.SUCCESS,
          message
        },
        { root: true }
      )
      return true
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.exceptionDesc || 'Ha habido un error enviando el email. Vuelve a intentarlo más tarde.'
      dispatch(
        `${dialogModule}/showDialog`,
        {
          type: DialogTypes.ERROR,
          message: errorMessage
        },
        { root: true }
      )
      return false
    }
  },

  async saveMessage({ rootGetters }, { notificationData }) {
    const url = `v2/internal-message`
    try {
      const user = rootGetters[`${ModuleNamespaces.AUTH}/getUser`]
      const formData: FormData = new FormData()
      formData.append('from', user.id)
      formData.append('to', notificationData.selectedResponsibles.map((res: any) => res.id).join(', '))
      formData.append('subject', notificationData.subject)
      formData.append('message', notificationData.noteText)
      formData.append('idAction', notificationData.actionId || null)
      formData.append('idExpedient', notificationData.idExpedient || null)
      await new MainService().postFormData(url, formData)
    } catch (_error) {}
  },

  async fetchInternalMessages({ commit }) {
    try {
      const url = `${process.env.VUE_APP_API_URL}notification/internal/get`
      const { data } = await new MainService().getData(url)
      commit(notificationsMutationTypes.FETCH_INTERNAL_MESSAGES, data)
    } catch (error: any) {
      throw new Error(error?.message || 'Error al cargar mensajes internos')
    }
  },
  async fetchLoginViewNotification({ commit }) {
    try {
      const url = `${process.env.VUE_APP_API_URL}notification/get`
      const { data } = await new ExternalService().getData(url)
      commit(notificationsMutationTypes.FETCH_LOGIN_VIEW_NOTIFICATION, data)
    } catch (error: any) {
      throw new Error(error?.message || 'Error al cargar notificación de login')
    }
  },

  async fetchContextInternalMessages({ commit }, { context, registerId }) {
    try {
      if (!registerId) {
        commit(notificationsMutationTypes.FETCH_CONTEXT_INTERNAL_MESSAGES, [])
        return
      }
      const endpoint = `/v2/internal-message/${context}/${registerId}`
      const { data } = await new MainService().getData(endpoint)
      commit(notificationsMutationTypes.FETCH_CONTEXT_INTERNAL_MESSAGES, data || [])
    } catch (_error) {
      commit(notificationsMutationTypes.FETCH_CONTEXT_INTERNAL_MESSAGES, [])
    }
  }
}
